/** Appearance of the inverted section (plot background, text colour, font, title, legend position). */
export const APPEARANCE_KEY = 'section.appearance';
export const FONT_FAMILIES = ['system-ui', 'Arial', 'Times New Roman', 'Georgia', 'Courier New'];

export function defaultAppearance(theme) {
  const light = theme === 'light';
  const bg = light ? '#ffffff' : '#0d1117';
  return {
    plotBg: bg, frameBg: bg,
    textColor: light ? '#111111' : '#e6edf3',
    axisColor: light ? '#444444' : '#8b949e',
    gridColor: light ? 'rgba(0,0,0,0.12)' : 'rgba(255,255,255,0.12)',
    fontFamily: 'system-ui', fontSize: 11,
    bold: false, italic: false, underline: false,
    titleText: '', showTitle: true, showGrid: false, legendPosition: 'right',
  };
}

/** Theme default overlaid with whatever the user saved in this browser. */
export function loadAppearance(theme) {
  const out = defaultAppearance(theme);
  try {
    const saved = JSON.parse(window.localStorage.getItem(APPEARANCE_KEY) || '{}') || {};
    Object.keys(out).forEach(k => { if (saved[k] !== undefined) out[k] = saved[k]; });
  } catch { /* ignore */ }
  return out;
}

export function saveAppearance(a) {
  try { window.localStorage.setItem(APPEARANCE_KEY, JSON.stringify(a)); } catch { /* ignore */ }
}

export function clearAppearance() {
  try { window.localStorage.removeItem(APPEARANCE_KEY); } catch { /* ignore */ }
}

/** SVG text attributes; `scale` shrinks secondary labels (legend ticks). */
export function textStyle(a, scale = 1) {
  return {
    fill: a.textColor,
    fontFamily: a.fontFamily,
    fontSize: Math.round(a.fontSize * scale * 10) / 10,
    fontWeight: a.bold ? 700 : 400,
    fontStyle: a.italic ? 'italic' : 'normal',
    textDecoration: a.underline ? 'underline' : 'none',
  };
}

/** A readable ink colour (for markers and lines) against the plot background. */
export function inkFor(bg) {
  const m = /^#([0-9a-f]{6})$/i.exec(bg || '');
  if (!m) return '#e6edf3';
  const n = parseInt(m[1], 16);
  const lum = (0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255;
  return lum > 0.55 ? '#111111' : '#e6edf3';
}
